export default __webpack_public_path__ + "static/media/208.e1c2e65e.png";